<template>
	<search-list ref="sl" apiPath="/channelSummary/list" :where="where" :order="order" :search-keys="searchKeys" :handleResponse="handleResponse"  >
		<mm-lc title="Period">
			<mm-month-picker v-model="where.time" />
		</mm-lc>
		<mm-lc title="Channel">
			<mm-channel-select v-model="where.channel_id" multiple/>
		</mm-lc>
		<mm-lc title="Manager">
			<mm-users v-model="where.manager" multiple/>
		</mm-lc>
		<mm-lc title="Auth Manager" v-show="is_show_auth">
			<mm-users v-model="where.auth_manager" multiple not_admin></mm-users>
		</mm-lc>
		<!-- <mm-lc title="Operator">
			<mm-users v-model="where.operator" multiple/>
		</mm-lc> -->
		<mm-lc title="status" v-if="is_show_status">
			<mm-summary-status v-model="where.status" multiple/>
		</mm-lc>
		<mm-lc title="Invoice Status">
			<mm-invoice-status v-model="where.invoice_status" />
		</mm-lc>
		<mm-lc title="Payout Type">
			<mm-payout-type-select v-model="where.payout_type" multiple/>
		</mm-lc>
		<el-dropdown size="mini" trigger="click" slot="statusAction">
			<el-button size="small" type="primary" icon="el-icon-edit">
				Batch Op
			</el-button>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item class="status-active" @click.native="invoiceDownload">Invoice Download</el-dropdown-item>
				<el-dropdown-item @click.native="copyFinRev">Copy Fin Cost</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
		<el-button slot="actions" type="success" class="el-icon-document-add" @click="showAddDialog = true"></el-button>
		<mm-table slot="dataTable" slot-scope="res" :res="res" @sort-change="sortChange" @selection-change="selectionChange">
			<el-table-column type="selection" fixed="left"/>
			<el-table-column label="Time" prop="time" fixed />
			<el-table-column label="Channel Id" width="100" prop="channel_id" fixed />
			<el-table-column label="Channel" prop="channel_name" fixed >
				<mm-get-detail slot-scope="sp" :row_id="sp.row.channel_id" :row_name="sp.row.channel_name" :row_type="'channel'"/>
			</el-table-column>
			<mm-summary-column label="Conv" prop="conv" width="85" sortable="custom"  />
			<mm-summary-column label="Rev" prop="snt_rev" sortable="custom" />
			<mm-summary-column label="Deducted Rev" prop="ded_rev" width="95" sortable="custom" />
			<mm-summary-column label="Sent Conv" prop="sent_conv" width="125" sortable="custom" />
			<mm-summary-column label="Cost" prop="snt_cost" sortable="custom" />
			<!-- <mm-summary-column label="Dash Cost" prop="dash_cost"  sortable="custom"/> -->
			<mm-summary-column label="Deducted Cost" prop="ded_cost"  width="100" sortable="custom"/>
			<mm-summary-column label="Ded Cost rate(%)" prop="ded_cost_rate"  sortable="custom"/>
			<mm-summary-column label="Processing Cost" prop="processing_cost"  width="107" sortable="custom"/>
			<mm-summary-column label="Hold On Cost" prop="hold_on_cost" sortable="custom" />
			<mm-summary-column label="Cover Cost" prop="cover_cost" sortable="custom" />
			<mm-summary-column label="Cover Rate" prop="cover_rate"/>
			<mm-summary-column label="Final Cost" prop="confirm_cost"  sortable="custom"/>
			<mm-summary-column label="Final Ded rate(%)" prop="fin_ded_rate"  sortable="custom"/>
			<mm-summary-column label="Final Cover" prop="fin_cover"/>
			<mm-summary-column label="Loss" prop="loss"/>
			<mm-summary-column label="Paid Amount" prop="paid_amount_rate" width="105" sortable="custom" />
			<mm-summary-column label="Profit Margin" prop="profit_margin" width="105"/>
			<el-table-column label="Manager" prop="manager" width="85" />
			<el-table-column label="Operator" prop="operator" width="85" />
			<el-table-column label="Payout Type" prop="payout_type"  width="105"/>
			<el-table-column label="status" prop="status" fixed="right" v-if="is_show_status">
				<span slot-scope="sp" :class="'status-'+sp.row.status.trim()">{{sp.row.status.toUpperCase()}}</span>
			</el-table-column>
			<el-table-column label="Invoice Status" prop="invoice_status" fixed="right" >
				<span slot-scope="sp" :class="'status-'+sp.row.invoice_status">{{sp.row.invoice_status.toUpperCase()}}</span>
			</el-table-column>
			<el-table-column label="action" fixed="right" >
				<template slot-scope="sp">
					<el-dropdown szie="small" trigger="click">
						<el-button type="primary" plain size="mini">Action</el-button>
						<el-dropdown-menu slot="dropdown" size="mini" >
							<el-dropdown-item @click.native="edit(sp.row)">Edit</el-dropdown-item>
							<el-dropdown-item v-show="!sp.row.processing_cost && !sp.row.hold_on_cost" @click.native="setConfirmCost(sp.row)">Set Final Cost</el-dropdown-item>
							<el-dropdown-item v-show="!sp.row.processing_cost && !sp.row.hold_on_cost" @click.native="sendMail(sp.row)">Send Mail</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>
			</el-table-column>

		</mm-table>

		<el-dialog :visible.sync="showAddDialog">
			<span slot="title">Add Channel Summary</span>
			<el-form label-width="200px" class="edit-timezone" :model="addForm" ref="addForm">
				<el-form-item label="Channel" required prop="channel_id">
					<mm-channel-select v-model="addForm.channel_id" style="width:300px"/>
				</el-form-item>
				<el-form-item label="Time" required prop="time">
					<el-date-picker append-to-body v-model="addForm.time" :picker-options="pickerOptions" type="month" value-format="yyyy-MM" style="width:300px"/>
				</el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click="addSummary">Save</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</search-list>
</template>

<script>
import { attachmentDownload } from '@/lib/index'
export default {
	
	data() {
		const searchKeys = {
			channel_id: { label: "Channel Id" },
			channel_name: { label: "Channel Name",fuzzy:true }
		};
		const user_info = this.$utils.getCookies(['group_name','is_super']);
		const is_show_auth = (user_info.group_name === 'admin');
		const is_show_status = user_info.is_super == '1'; 
		return {
			searchKeys,
			where: {
			},
			order:[],
			is_show_auth,
			is_show_status,
			addForm: {},
			showAddDialog: false,
			pickerOptions: {
				disabledDate: (date) => {
					const nowMonth = this.$utils.date_format((new Date()),'YYYY-MM');
					if (new Date(date).getTime() < new Date(nowMonth).getTime() - 24 * 60 * 60 * 1000) {
						return false;
					}
					return true;
				}
			},
			selected: [],
		};
	},
	methods: {

		selectionChange(v) {
			this.selected = v || [];
		},
		async invoiceDownload() {
			if (!this.selected.length) {
				this.$message({ message: "no selection!", type: "warning" });
				return;
			}
			const errArr = [];
			const emtyArr = [];
			for(const row of this.selected) {
				if (row.invoice_file) {
					const invoice_files = JSON.parse(row.invoice_file);
					for (const fileInfo of invoice_files) {
						if (fileInfo && fileInfo.file_path) {
							attachmentDownload(fileInfo);
						} else {
							errArr.push(row.channel_name);
						}
					}
				} else {
					emtyArr.push(row.channel_name);
				}
			}
			let textArr = [];
			if (errArr.length) {
				textArr.push(errArr.join(',') + ': invoice file Error;')
			}
			if (emtyArr.length) {
				textArr.push(emtyArr.join(',') + ': invoice file have not sent;')
			}
			if (textArr.length) {
				this.$message.error({
					message: textArr.join('<br/>'),
					dangerouslyUseHTMLString: true,
				});
			}
		},
		copyFinRev() {
			if (!this.selected.length) {
				this.$message({ message: "no selection!", type: "warning" });
				return;
			}
			let text = '';
			let total = 0;
			for (const row of this.selected) {
				text += row.time + '\t' + row.channel_name + '\t' + row.confirm_cost + '\r';
				total += Number(row.confirm_cost);
			}
			text += 'Total\t' + total;
			this.$copyText(text);
			this.$message.success('Copy Success');
		},
		edit(row){
			window.open(`/channelSummaryEdit?id=${row.id}`);
		},
		async sortChange(column){
			if(column.order == 'ascending'){
				this.$set(this.order, 0, [column.prop, 'asc']);
			}else if(column.order == 'descending'){
				this.$set(this.order, 0, [column.prop, 'desc']);
			}else {
				this.order.splice(0,this.order.length);
			}
			await this.$refs.sl.refresh();
		},
		handleResponse(res) {
			for (const n in res.rows) {
				if (res.rows[n].time) {
					res.rows[n].time = this.$utils.columnTimestamp2Month(null, null, res.rows[n].time);
				}
			}
		},
		async addSummary() {
			await this.$validate(this.$refs.addForm);
            await this.$post('channelSummary/create',this.addForm);
			await this.$refs.sl.refresh();
			this.showAddDialog = false;
		},
		async setConfirmCost(row) {
			const confirm_cost = Number((row.snt_cost - row.ded_cost).toFixed(2));
			await this.$post('channelSummary/setConfirmCost', { id: row.id, confirm_cost: confirm_cost });
			await this.$refs.sl.refresh();
		},
		async sendMail(row) {
			const request_path = "/channelSummary/remind";
			const data = await this.$post("/channelSummary/detail", {
				id: row.id
			});
			const result = await this.$post(request_path, data);
		},
	},
	
};
</script>

<style scoped>
.bt-create {
  position: relative;
  right: 0px;
}
</style>
